'use strict';

var trapFocus = require('../utilities/focusTrap').trapFocus;

/**
 * Main module export - initializes lip icon component
 */
module.exports = function () {
    $(window).on('load', initLipIcon);
};

/**
 * Initializes lip icon component with show/hide behavior based on newsletter position
 */
function initLipIcon() {
    // CSS selectors for DOM elements
    const SELECTORS = {
        ICON_BUTTON: '#lipIconButton',
        WRAPPER: '.lip-icon',
        MENU: '#lipIconMenu',
        CLOSE_BUTTON: '#closeLipIconMenu',
        NEWSLETTER_SECTION: '.footer-newsletter',
    };

    // CSS class names for state management
    const CLASS_NAMES = {
        VISIBLE: 'is-visible',
        HIDDEN: 'lip-icon--hidden'
    };

    // jQuery references to DOM elements
    const $iconBtn = $(SELECTORS.ICON_BUTTON);
    const $wrapper = $(SELECTORS.WRAPPER);
    const $menu = $(SELECTORS.MENU);
    const $closeBtn = $(SELECTORS.CLOSE_BUTTON);

    // Early return if required elements don't exist
    if (!$iconBtn.length || !$wrapper.length || !$menu.length || !$closeBtn.length) {
        return;
    }

    // State variables
    let releaseFocus = null; // Function to release focus trap

    /**
     * Opens the lip icon menu and traps focus for accessibility
     */
    function openMenu() {
        $wrapper.addClass(CLASS_NAMES.VISIBLE);
        releaseFocus = trapFocus($menu[0]);
        $closeBtn.trigger('focus');
    }

    /**
     * Closes the lip icon menu and releases focus trap
     */
    function closeMenu() {
        $wrapper.removeClass(CLASS_NAMES.VISIBLE);
        if (releaseFocus) {
            releaseFocus();
            releaseFocus = null;
        }
        $iconBtn.trigger('focus');
    }

    /**
     * Initializes all event listeners for the component
     */
    function initEventListeners() {
        // Click events
        $iconBtn.on('click', openMenu);
        $closeBtn.on('click', closeMenu);

        // Keyboard accessibility - close on Escape key
        $(document).on('keydown', (e) => {
            if (e.key === 'Escape' && $wrapper.hasClass(CLASS_NAMES.VISIBLE)) {
                closeMenu();
            }
        });
    }

    // Start the component initialization
    initEventListeners();
}